import * as React from 'react'

const CheckIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_16149_38213)">
      <rect width="32" height="32" rx="16" fill="#EEF4FF" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.7953 9.8534L13.2487 19.0667L10.7153 16.3601C10.2487 15.9201 9.51534 15.8934 8.982 16.2667C8.462 16.6534 8.31534 17.3334 8.63534 17.8801L11.6353 22.7601C11.9287 23.2134 12.4353 23.4934 13.0087 23.4934C13.5553 23.4934 14.0753 23.2134 14.3687 22.7601C14.8487 22.1334 24.0087 11.2134 24.0087 11.2134C25.2087 9.98674 23.7553 8.90674 22.7953 9.84007V9.8534Z"
        fill="#444CE7"
      />
      <rect
        x="1"
        y="1"
        width="30"
        height="30"
        rx="15"
        stroke="#444CE7"
        strokeWidth="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_16149_38213">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default CheckIcon
